import React, { useContext } from 'react';
import InputMask from 'react-input-mask';

import FormFieldError from './FormFieldError';
import FormFieldLabel from './FormFieldLabel';
import FormFieldTooltip, { TooltipSource } from './FormFieldTooltip';
import { FormProvider } from './FormProvider';
import useFormField, { FieldEvent, FieldWidth } from './useFormField';

interface IProps {
  name: string;
  mask: string | Array<string | RegExp>;
  label?: string;
  tooltip?: TooltipSource;
  description?: string;
  disabled?: boolean;
  width?: FieldWidth;
  onFocus?: FieldEvent<string>;
  onChange?: FieldEvent<string>;
  onBlur?: FieldEvent<string>;
  alwaysShowMask?: boolean;
}

function FormMaskField({
  name,
  mask,
  label,
  tooltip,
  description,
  disabled,
  width,
  onFocus,
  onChange,
  onBlur,
  alwaysShowMask = false,
}: IProps) {
  const { maskChar } = useContext(FormProvider);
  const onChangeHandler = (
    value: string,
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void,
  ) => {
    const valueFormatted = value.replace(new RegExp(maskChar, 'gi'), '');
    setFieldValue(name, valueFormatted);

    if (onChange) {
      onChange(valueFormatted, setFieldValue);
    }
  };

  const {
    id,
    fieldProps,
    inputProps,
    required,
    disabled: formDisabled,
  } = useFormField<string>(name, width, { onFocus, onChange: onChangeHandler, onBlur });

  return (
    <div {...fieldProps}>
      {label && (
        <div className="novoFormField__name">
          <FormFieldLabel for={id} required={required}>
            {label}
          </FormFieldLabel>
          <FormFieldTooltip source={tooltip} />
        </div>
      )}
      {description && <p className="novoFormField__description">{description}</p>}
      <InputMask
        id={id}
        mask={mask}
        maskPlaceholder={maskChar}
        alwaysShowMask={alwaysShowMask}
        className="novoFormField__input"
        {...inputProps}
        required={required}
        disabled={formDisabled || disabled}
        value={inputProps.value || ''}
      />
      <FormFieldError name={name} />
    </div>
  );
}

export default FormMaskField;
